module.exports = __webpack_public_path__ + "media/images/font/Gustavo-BoldItalic-5e4ebdc47efe376af1d2ecf29a97d228.ttf";